export default "/images/f6541d13391ee0a38fa81ee715ad80fb.avif";